//#region src/api-deprecation.ts
/**
* API deprecation contract — the canonical 410 Gone surface for the platform.
*
* Producers:
*   - DP services that retain a thin shim for an endpoint moved/removed in a
*     newer release. Use the `@RetiredEndpoint` decorator from
*     `@zion/sdk-nestjs` to emit the response shape declared here.
*
* Consumers:
*   - The platform shell (`@zion/shell-v3`) — when an SPA fetch hits 410 the
*     shell renders a "this endpoint has moved" surface and, when
*     `replacement` is present, links to it.
*   - Tests that assert deprecation behavior — use the constants and the
*     `isDeprecationResponse` type guard to avoid string-literal duplication.
*
* The contracts package is type-only — keep this file zero-dep. Any other 410
* surface in the platform must use these types or be added to the SDK-017
* allowlist with justification.
*/
/** HTTP status code for a retired endpoint. RFC 9110 §15.5.11 — Gone. */
const RETIRED_STATUS = 410;
/**
* Type guard for `DeprecationResponse`. Defensive — checks every required
* field including `retired === true`, and rejects bodies where any optional
* field is the wrong type.
*/
function isDeprecationResponse(value) {
	if (value === null || typeof value !== "object") return false;
	const v = value;
	if (v["retired"] !== true) return false;
	if (typeof v["message"] !== "string") return false;
	if (v["replacement"] !== void 0 && typeof v["replacement"] !== "string") return false;
	if (v["sunsetAt"] !== void 0 && typeof v["sunsetAt"] !== "string") return false;
	return true;
}
//#endregion
export { RETIRED_STATUS, isDeprecationResponse };

//# sourceMappingURL=api-deprecation.js.map